// // src/pages/documents/CarRegistrationDocumentUploadScreen.jsx
// import React, { useContext, useState, useEffect } from "react";
// import {
//   View,
//   Text,
//   StyleSheet,
//   Pressable,
//   Image,
//   ScrollView,
//   ActivityIndicator,
//   Alert,
// } from "react-native";
// import * as ImagePicker from "expo-image-picker";
// import * as DocumentPicker from "expo-document-picker";
// import { AppContext } from "../../../App";
// import { uploadVerificationDocument } from "../../api/verificationApi";
// import { useFormNavigation } from "../../utils/navigationUtils";
// import Header from "../../components/Header";
// import { useTranslation } from "../../i18n";
// import { useFileValidation } from "../../hooks/useFileValidation";
// import FileSizeErrorModal from "../../components/FileSizeErrorModal";

// const COLORS = {
//   primary: "#7C3AED",
//   background: "#F7F9FA",
//   card: "#FFFFFF",
//   textDark: "#1C1C1E",
//   textMuted: "#6B7280",
//   error: "#DC2626",
//   border: "#E5E7EB",
// };

// function CheckRow({ label, checked, onPress }) {
//   return (
//     <Pressable onPress={onPress} style={styles.checkRow}>
//       <View style={[styles.checkBox, checked && styles.checkBoxOn]}>
//         {checked ? <Text style={styles.checkMark}>✓</Text> : null}
//       </View>
//       <Text style={styles.checkLabel}>{label}</Text>
//     </Pressable>
//   );
// }

// const CarRegistrationDocumentUploadScreen = ({ navigation }) => {
//   const { verification, setVerification, setFormProgress } = useContext(AppContext);
//   const { goToNextStep, updateCurrentStep } = useFormNavigation();
//   const { t } = useTranslation();
//   const { validateFile, formatFileSize } = useFileValidation();

//   const [files, setFiles] = useState([]);
//   const [uploading, setUploading] = useState(false);
//   const [error, setError] = useState(null);
//   const [skip, setSkip] = useState(false);

//   // File error modal state
//   const [showFileErrorModal, setShowFileErrorModal] = useState(false);
//   const [invalidFile, setInvalidFile] = useState(null);
//   const [fileErrorMessage, setFileErrorMessage] = useState("");

//   useEffect(() => {
//     updateCurrentStep("car_registration_doc_upload");
//   }, []);

//   useEffect(() => {
//     if (files.length > 0) {
//       setVerification((prev) => ({
//         ...prev,
//         documents: {
//           ...prev.documents,
//           carteGrise: files,
//         },
//       }));
//     }
//   }, [files]);

//   const validateAndAddFile = (newFile) => {
//     // Check file size
//     const validation = validateFile(newFile);
    
//     if (!validation.isValid) {
//       // Show error modal with the first error
//       const error = validation.errors[0];
//       setInvalidFile({
//         name: newFile.name,
//         size: newFile.size ? formatFileSize(newFile.size) : null
//       });
//       setFileErrorMessage(error.message);
//       setShowFileErrorModal(true);
//       return false;
//     }
    
//     return true;
//   };

//   const handlePickFromCamera = async () => {
//     setError(null);
//     const perm = await ImagePicker.requestCameraPermissionsAsync();
//     if (!perm.granted) {
//       setError(t("documentUpload.cameraPermissionDenied"));
//       return;
//     }

//     const result = await ImagePicker.launchCameraAsync({
//       mediaTypes: ImagePicker.MediaTypeOptions.Images,
//       quality: 0.6, // Reduce quality to reduce file size
//       allowsEditing: true,
//     });

//     if (!result.canceled && result.assets?.[0]) {
//       const a = result.assets[0];
      
//       // Get file size for camera images (approximate)
//       const fileInfo = {
//         uri: a.uri,
//         name: a.fileName || "carte_grise_photo.jpg",
//         mimeType: "image/jpeg",
//         type: "image/jpeg",
//         size: a.fileSize || 0,
//       };

//       if (validateAndAddFile(fileInfo)) {
//         setFiles((prev) => [...prev, fileInfo]);
//       }
//     }
//   };

//   const handlePickDocument = async () => {
//     setError(null);
//     try {
//       const result = await DocumentPicker.getDocumentAsync({
//         type: ["application/pdf", "image/*"],
//         copyToCacheDirectory: true,
//       });

//       if (result.canceled) return;

//       const assets = result.assets || [];
      
//       for (const a of assets) {
//         const fileInfo = {
//           uri: a.uri,
//           name: a.name || "carte_grise_doc",
//           mimeType: a.mimeType || "application/octet-stream",
//           type: a.mimeType || "application/octet-stream",
//           size: a.size || 0,
//         };

//         if (validateAndAddFile(fileInfo)) {
//           setFiles((prev) => [...prev, fileInfo]);
//         }
//       }
//     } catch (err) {
//       console.error("Document picker error:", err);
//       setError("Erreur lors de la sélection du fichier");
//     }
//   };

//   const handleRemoveFile = (idx) => {
//     setFiles((prev) => prev.filter((_, i) => i !== idx));
//   };

//   const handleNext = async () => {
//     if (!verification.verificationId) {
//       setError(t("documentUpload.noVerificationFound"));
//       return;
//     }

//     // ✅ Skip: allow continuing without upload and without backend calls
//     if (skip) {
//       setFormProgress((prev) => ({
//         ...prev,
//         completedSteps: [
//           ...new Set([...prev.completedSteps, "car_registration_doc_upload"]),
//         ],
//         currentStep: "public_transport_doc_upload",
//       }));

//       setVerification((prev) => ({
//         ...prev,
//         documents: {
//           ...(prev?.documents || {}),
//           carteGrise: [],
//           carRegistrationSkipped: true,
//         },
//       }));

//       goToNextStep("public_transport_doc_upload");
//       return;
//     }

//     if (files.length === 0) {
//       setError(t("documentUpload.addAtLeastOne"));
//       return;
//     }

//     // Double-check file sizes before upload
//     const oversizedFiles = files.filter(f => f.size > 15 * 1024 * 1024);
//     if (oversizedFiles.length > 0) {
//       const file = oversizedFiles[0];
//       setInvalidFile({
//         name: file.name,
//         size: formatFileSize(file.size)
//       });
//       setFileErrorMessage(t('fileValidation.fileTooLarge', { 
//         maxSize: '15MB',
//         fileName: file.name 
//       }));
//       setShowFileErrorModal(true);
//       return;
//     }

//     try {
//       setUploading(true);
//       setError(null);

//       for (const f of files) {
//         await uploadVerificationDocument(
//           verification.verificationId,
//           "CARTE_GRISE",
//           f
//         );
//       }

//       setFormProgress((prev) => ({
//         ...prev,
//         completedSteps: [
//           ...new Set([...prev.completedSteps, "car_registration_doc_upload"]),
//         ],
//         currentStep: "public_transport_doc_upload",
//       }));

//       goToNextStep("public_transport_doc_upload");
//     } catch (e) {
//       console.log("Upload error:", e);
      
//       // Check if error is due to file size
//       if (e.response?.status === 413 || e.message?.includes('413') || e.message?.includes('too large')) {
//         setError(t('fileValidation.backendFileTooLarge', 'Le fichier est trop volumineux pour le serveur. Taille maximum: 15MB.'));
//       } else {
//         setError(t("documentUpload.uploadError"));
//       }
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <View style={styles.screen}>
//       <Header />
      
//       {/* File Size Error Modal */}
//       <FileSizeErrorModal
//         visible={showFileErrorModal}
//         onDismiss={() => setShowFileErrorModal(false)}
//         errorMessage={fileErrorMessage}
//         fileName={invalidFile?.name}
//         fileSize={invalidFile?.size}
//         onRetry={() => {
//           setShowFileErrorModal(false);
//           setInvalidFile(null);
//           // Optionally open file picker again
//         }}
//       />
      
//       <ScrollView contentContainerStyle={styles.scroll}>
//         {/* Back button */}
//         <Pressable
//           style={styles.backButton}
//           onPress={() => navigation.navigate("vehicle_admin_info")}
//         >
//           <Text style={styles.backIcon}>←</Text>
//         </Pressable>
        
//         <Text style={styles.title}>{t("documentUpload.registrationTitle")}</Text>
//         <Text style={styles.subtitle}>
//           {t("documentUpload.registrationSubtitle")}
//         </Text>

//         <View style={styles.card}>
//           <Pressable style={styles.uploadOption} onPress={handlePickFromCamera}>
//             <Image
//               source={require("../../../assets/camera.png")}
//               style={styles.icon}
//             />
//             <View>
//               <Text style={styles.optionTitle}>{t("documentUpload.takePhoto")}</Text>
//               <Text style={styles.optionHint}>
//                 {t("documentUpload.photoHint")}
//               </Text>
//             </View>
//           </Pressable>

//           <Pressable style={styles.uploadOption} onPress={handlePickDocument}>
//             <Image
//               source={require("../../../assets/file_upload.png")}
//               style={styles.icon}
//             />
//             <View>
//               <Text style={styles.optionTitle}>{t("documentUpload.importFile")}</Text>
//               <Text style={styles.optionHint}>
//                 {t("documentUpload.fileFormats")} (Max 15MB)
//               </Text>
//             </View>
//           </Pressable>
//         </View>

//         {files.map((f, idx) => (
//           <View key={idx} style={styles.fileRow}>
//             <View style={{ flex: 1 }}>
//               <Text style={styles.fileName} numberOfLines={1}>
//                 {f.name}
//               </Text>
//               {f.size > 0 && (
//                 <Text style={styles.fileSize}>
//                   {formatFileSize(f.size)}
//                 </Text>
//               )}
//             </View>
//             <Pressable onPress={() => handleRemoveFile(idx)}>
//               <Text style={styles.remove}>{t("documentUpload.remove")}</Text>
//             </Pressable>
//           </View>
//         ))}

//         {error && <Text style={styles.error}>{error}</Text>}

//         {/* ✅ Skip checkbox */}
//         <Pressable
//           onPress={() => setSkip((v) => !v)}
//           style={({ pressed }) => [
//             styles.skipRow,
//             pressed && { opacity: 0.85 },
//           ]}
//         >
//           <View style={[styles.skipBox, skip && styles.skipBoxOn]}>
//             {skip ? <Text style={styles.skipMark}>✓</Text> : null}
//           </View>
//           <Text style={styles.skipLabel}>{t("documentUpload.skip")}</Text>
//         </Pressable>

//         {/* File size info */}
//         <View style={styles.fileInfoHint}>
//           <Text style={styles.fileInfoText}>
//             📁 {t('fileValidation.maxSizeHint', 'Taille maximale: 15MB')}
//           </Text>
//           <Text style={styles.fileInfoText}>
//             📄 {t('fileValidation.allowedFormats', 'Formats acceptés: PDF, JPG, PNG')}
//           </Text>
//         </View>

//         <Pressable
//           onPress={handleNext}
//           disabled={(!skip && files.length === 0) || uploading}
//           style={[
//             styles.cta,
//             ((!skip && files.length === 0) || uploading) && { opacity: 0.5 },
//           ]}
//         >
//           {uploading ? (
//             <ActivityIndicator color="#FFF" />
//           ) : (
//             <Text style={styles.ctaText}>{t("documentUpload.next")}</Text>
//           )}
//         </Pressable>
//       </ScrollView>
//     </View>
//   );
// };

// const styles = StyleSheet.create({
//   screen: {
//     flex: 1,
//     backgroundColor: COLORS.background,
//   },
//   backButton: {
//     width: 42,
//     height: 42,
//     borderRadius: 12,
//     backgroundColor: "#fff",
//     alignItems: "center",
//     justifyContent: "center",
//     marginBottom: 8,
//     marginTop: 16,
//   },
//   backIcon: {
//     fontSize: 18,
//     color: COLORS.textDark,
//   },
//   scroll: {
//     paddingHorizontal: 16,
//     paddingBottom: 40,
//   },
//   title: {
//     fontSize: 24,
//     fontWeight: "800",
//     textAlign: "center",
//     marginBottom: 6,
//   },
//   subtitle: {
//     textAlign: "center",
//     color: COLORS.textMuted,
//     marginBottom: 24,
//   },
//   card: {
//     backgroundColor: COLORS.card,
//     borderRadius: 16,
//     padding: 16,
//     marginBottom: 16,
//     shadowColor: "#000",
//     shadowOpacity: 0.05,
//     shadowRadius: 10,
//     elevation: 3,
//   },
//   uploadOption: {
//     flexDirection: "row",
//     alignItems: "center",
//     paddingVertical: 12,
//   },
//   icon: {
//     width: 36,
//     height: 36,
//     marginRight: 12,
//   },
//   optionTitle: {
//     fontSize: 15,
//     fontWeight: "700",
//   },
//   optionHint: {
//     fontSize: 12,
//     color: COLORS.textMuted,
//   },
//   fileRow: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     paddingVertical: 8,
//     borderBottomWidth: 1,
//     borderBottomColor: COLORS.border,
//   },
//   fileName: {
//     fontSize: 14,
//     maxWidth: 250,
//   },
//   fileSize: {
//     fontSize: 12,
//     color: COLORS.textMuted,
//     marginTop: 2,
//   },
//   remove: {
//     fontSize: 12,
//     color: COLORS.error,
//   },
//   error: {
//     color: COLORS.error,
//     marginBottom: 8,
//   },
//   fileInfoHint: {
//     marginTop: 16,
//     marginBottom: 8,
//     padding: 12,
//     backgroundColor: '#F3F4F6',
//     borderRadius: 8,
//   },
//   fileInfoText: {
//     fontSize: 12,
//     color: COLORS.textMuted,
//     marginBottom: 4,
//   },
//   // Skip checkbox
//   skipRow: {
//     flexDirection: "row",
//     alignItems: "center",
//     gap: 10,
//     marginTop: 8,
//     marginBottom: 6,
//   },
//   skipBox: {
//     width: 22,
//     height: 22,
//     borderRadius: 6,
//     borderWidth: 1,
//     borderColor: COLORS.border,
//     backgroundColor: "#fff",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   skipBoxOn: {
//     backgroundColor: COLORS.primary,
//     borderColor: COLORS.primary,
//   },
//   skipMark: { color: "#fff", fontWeight: "900" },
//   skipLabel: { color: COLORS.textDark, fontWeight: "700" },

//   // Generic checkbox style (used by CheckRow)
//   checkRow: {
//     flexDirection: "row",
//     alignItems: "center",
//     gap: 10,
//     marginTop: 6,
//     marginBottom: 6,
//   },
//   checkBox: {
//     width: 22,
//     height: 22,
//     borderRadius: 6,
//     borderWidth: 1,
//     borderColor: COLORS.border,
//     backgroundColor: "#fff",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   checkBoxOn: {
//     backgroundColor: COLORS.primary,
//     borderColor: COLORS.primary,
//   },
//   checkMark: { color: "#fff", fontWeight: "900" },
//   checkLabel: { color: COLORS.textDark, fontWeight: "700" },

//   cta: {
//     backgroundColor: COLORS.primary,
//     paddingVertical: 14,
//     borderRadius: 14,
//     alignItems: "center",
//     marginTop: 12,
//   },
//   ctaText: {
//     color: "#FFF",
//     fontSize: 16,
//     fontWeight: "700",
//   },
// });

// export default CarRegistrationDocumentUploadScreen;

import React from 'react';
import TwoSidedDocumentUploadScreen from './TwoSidedDocumentUploadScreen';

export default function CarRegistrationDocumentUploadScreen(props) {
  return (
    <TwoSidedDocumentUploadScreen
      {...props}
      routeName="car_registration_doc_upload"
      previousRoute="vehicle_admin_info"
      nextRoute="public_transport_doc_upload"
      docType="CARTE_GRISE"
      docKey="carteGrise"
      skipFlag="carRegistrationSkipped"
      title="Carte grise"
      subtitle="Ajoutez le recto et le verso de la carte grise, ou importez un PDF complet."
    />
  );
}